import Http from '../http'

export const index = (data) => Http.get(`/reports?types=${data.types}&from=${data.from}&to=${data.to}`, { headers: { Authorization: localStorage.token } })
